<template>
  <div class="Pie1Charts">
    <div class="echarts" :id="Configuration.id"></div>
    <div class="no-data" v-if="noData">
      <sapn>暂无数据！</sapn>
    </div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import { getFilterValue } from '../../../../utils/tool';
import { request } from '../../../../common/request';

export default {
  name: 'Pie1Charts',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      noData: false,
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
    // 默认取api参数
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    // console.log('aaaa',params);
    this.params = eval('(' + params + ')');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  computed: {},
  methods: {
    getFilterValue(e) {
      return getFilterValue(e);
    },
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      if (Object.keys(ParamData).length == 0 || ParamData.source.length === 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        console.log(ParamData.source, 'ParamData.source');
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      let ConvertedData = [];
      function DealData() {
        seriesList.forEach(s => {
          source.forEach(item => {
            if (s === item.s) {
              ConvertedData.push({
                name: item.x,
                value: item.y,
                unit: item.s,
              });
            }
          });
        });
      }
      DealData();

      let dashedPic =
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM8AAAAOBAMAAAB6G1V9AAAAD1BMVEX////Kysrk5OTj4+TJycoJ0iFPAAAAG0lEQVQ4y2MYBaNgGAMTQQVFOiABhlEwCugOAMqzCykGOeENAAAAAElFTkSuQmCC';

      let chartData = ConvertedData;
      let arrName = [];
      let arrValue = [];
      let sum = 0;
      let pieSeries = [],
        lineYAxis = [];

      // 数据处理
      chartData.forEach(v => {
        arrName.push(v.name);
        arrValue.push(v.value);
        sum = sum + v.value;
      });

      // 图表option整理
      chartData.forEach((v, i) => {
        pieSeries.push({
          // name: '沪昆线到达晚点情况',
          type: 'pie',
          clockWise: false,
          hoverAnimation: false,
          radius: [85 - i * 10 + '%', 86.5 - i * 10 + '%'],
          center: ['42%', '50%'],
          label: {
            show: false,
          },
          itemStyle: {
            borderRadius: 20,
          },
          color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: chartColor[i] }, // 设置颜色渐变
            { offset: 1, color: 'transparent' },
          ]),
          data: [
            {
              value: v.value,
              name: v.name,
            },
            {
              value: sum - v.value,
              name: '',
              itemStyle: {
                color: 'rgba(0,0,0,0)',
              },
            },
          ],
        });
        pieSeries.push({
          name: '',
          type: 'pie',
          silent: true,
          z: 1,
          clockWise: false, //顺时加载
          hoverAnimation: false, //鼠标移入变大
          radius: [85 - i * 10 + '%', 86.5 - i * 10 + '%'],
          center: ['42%', '50%'],
          label: {
            show: false,
          },
          itemStyle: {
            borderCap: 'round',
            borderJoin: 'round',
          },
          data: [
            {
              value: 7.5,
              itemStyle: {
                color: '#cccccc30',
              },
            },
            {
              value: 2.5,
              name: '',
              itemStyle: {
                color: 'rgba(0,0,0,0)',
              },
            },
          ],
        });
        v.percent = ((v.value / sum) * 100).toFixed(1) + '%';
        lineYAxis.push({
          value: i,
          textStyle: {
            rich: {
              circle: {
                color: chartColor[i],

                padding: [0, 5],
              },
            },
          },
        });
      });

      this.echartsOptions = {
        backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
        // color:
        //   new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //     { offset: 0, color: 'transparent' }, // 设置颜色渐变
        //     {
        //       offset: 1, color: chartColor
        //       // chartColor.replace('1)', '0)')
        //     }
        //   ]),
        //  chartColor,
        grid: {
          ...grid,

          top: '5%',
          bottom: '70%',
          containLabel: false,
        },
        yAxis: [
          {
            type: 'category',
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: params => {
                let item = chartData[params];
                return '{circle|●}{name|' + item.name + '}{bd||}{percent|' + item.percent + '}';
              },
              // 数值 单位
              // '}{value|' +
              //   item.value +
              //   '}{unit| ' +
              //   item.unit +
              interval: 0,
              inside: true,
              textStyle: {
                fontSize: this.$h_Ratio(14, this.$store),
                rich: {
                  line: {
                    width: 170,
                    height: 10,
                    backgroundColor: { image: dashedPic },
                  },
                  name: {
                    color: fontStyle.yAxisColor,
                    fontSize: this.$h_Ratio(fontStyle.yAxisSize, this.$store),
                  },
                  bd: {
                    color: fontStyle.yAxisColor,
                    padding: [0, 5],
                    fontSize: this.$h_Ratio(fontStyle.yAxisSize, this.$store),
                  },
                  percent: {
                    color: fontStyle.yAxisColor,
                    fontSize: this.$h_Ratio(fontStyle.yAxisSize, this.$store),
                  },
                  value: {
                    color: fontStyle.yAxisColor,
                    fontSize: this.$h_Ratio(fontStyle.yAxisSize, this.$store),
                    fontWeight: 500,
                    padding: [0, 0, 0, 20],
                  },
                  unit: {
                    color: fontStyle.xAxisColor,
                    fontSize: this.$h_Ratio(fontStyle.xAxisSize, this.$store),
                  },
                },
              },
              show: true,
            },
            data: lineYAxis,
          },
        ],
        xAxis: [
          {
            show: false,
          },
        ],
        series: pieSeries,
      };
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.staticIntervalTaskID = setInterval(() => {
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          console.log(res, '78787878787878');
          this.setEchartsOptions(res);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          console.log(this.params, 'else else apiData?.apiUrlMethod');
          let params = ChartsData.apiData.apiPostParams || {};
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          console.log(filter_text, 'filter_text');
          eval(filter_text);
          console.log(dataSet, 'dataSet');
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.init(mychartDom, 'dark');
      mychart.setOption(this.echartsOptions);
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
  },

  Configuration: {
    componentTitle: '多轴环形图',
    componentName: 'Pie1Charts',
    componentOverViewImg: './img/charts/PieCharts/Pie1Charts.png',
    id: '',
    style: {
      width: 300,
      height: 150,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: ['#FF8700', '#ffc300', '#00e473', '#009DFF', '#0034ff'],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['列'],
            source: [
              {
                x: '早1发',
                y: 40083,
                s: '列',
                i: 1,
              },
              {
                x: '正点发',
                y: 33974,
                s: '列',
                i: 2,
              },
              {
                x: '晚2发',
                y: 15400,
                s: '列',
                i: 3,
              },
              {
                x: '早点',
                y: 11021,
                s: '列',
                i: 4,
              },
              {
                x: '晚点',
                y: 30696,
                s: '列',
                i: 5,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 150,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          top: '17%',
          bottom: '57%',
          left: '40%',
          right: '45%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Pie1Charts {
  color: white;
  width: 100%;
  height: 100%;

  .echarts {
    width: 100%;
    height: 100%;
  }
  .no-data {
    width: 100%;
    height: 100%;
    // background: #000;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #ccc;
  }
}
</style>
